var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationProvider',{attrs:{"name":"Tennis Court","rules":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('Dropdown',{attrs:{"fieldId":'tennisCourt' + _vm.idSuffix,"value":_vm.value,"error":errors[0],"options":_vm.tennisCourtOptions,"placeholder":"Select tennis court","label":"Tennis Court"},on:{"input":_vm.onInput}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }